var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"boxContainer mb-5",attrs:{"cols":"12"}},[_c('div',{staticClass:"box2"},[_c('div',{staticClass:"titleClass",style:('font-size:' + _vm.fontSize + ';')},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('div',{staticClass:"box1"},[_c('div',{staticClass:"subTitleClass"},[_vm._v(_vm._s(_vm.subTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }